import { render, staticRenderFns } from "./order_link_poup.vue?vue&type=template&id=acb60862&scoped=true"
import script from "./order_link_poup.vue?vue&type=script&lang=js"
export * from "./order_link_poup.vue?vue&type=script&lang=js"
import style0 from "./order_link_poup.vue?vue&type=style&index=0&id=acb60862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb60862",
  null
  
)

export default component.exports